import mainService from "./authService";

export function subscribe(data) {
    return mainService
        .post("/join-our-community", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}


export function educationCategory(data) {
    return mainService
        .get("/education-category")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}


// WEBPACK FOOTER //
// ./src/services/common.jsx